import { Box } from "@mui/material";
import { DungeonsKeys } from "./DungeonsKeysData";
import SmallKeyItem from "./SmallKeyItem";
import BossKeyItem from "./BossKeyItem";




interface DungeonKeysTrackingProps {
    dungeon: DungeonsKeys
    id: string
    keysy?: boolean
    keyring?: boolean
}


const DungeonKeysTracking = (props: DungeonKeysTrackingProps) => {

    if(props.dungeon.nbKeysVanilla === 0)
        return null;
    return <Box display={"flex"} flexDirection={"column"}marginRight={1}>
        <Box textAlign={"center"}>{props.dungeon.dungeon}</Box>
        {!props.keysy && <Box marginBottom={1}><SmallKeyItem data={props.dungeon} id={props.id} /></Box>}
        <Box marginTop={"15px"}> <BossKeyItem data={props.dungeon} id={props.id} /></Box>
    </Box>
}

export const DungeonKeysTrackingHorizontal = (props: DungeonKeysTrackingProps) => {

    if(props.dungeon.nbKeysVanilla === 0)
        return <Box ></Box>;

    return <Box display={"flex"} flexDirection={"row"} >
        {!props.keysy && <Box display={"flex"}> <SmallKeyItem data={props.dungeon}  keyring={props.keyring} id={props.id} /></Box>}
        <Box> <BossKeyItem data={props.dungeon} id={props.id} /></Box>
    </Box>
}

export default DungeonKeysTracking